import type { PlayersApi } from "@/v2/api/metadata/players";
import {
  addFeedMappingRow,
  buildFeedMappingGrid,
  createFeedMappingSubmitGate,
  fetchFeedTypeMappingsList,
} from "@/v2/kits/feed-mapping";
import type { GridTab, GridTabSaveContext } from "@/v2/framework/dialog/types";
import { notifySuccess, playerId } from "../shared";

export function createFeedMappingTab(players: PlayersApi): GridTab {
  async function save(ctx: GridTabSaveContext): Promise<void> {
    const gate = ctx.gate;
    if (!gate?.hasSuccessfulLoad() || !gate.isDirty()) return;
    if (!gate.validateForDialogSubmit()) {
      throw new Error("Please fill the required fields");
    }

    const fragment = gate.buildMergeFragment();
    if (!fragment) return;

    const entityId = playerId(ctx.values);
    await players.update(entityId, fragment);

    if (!ctx.rows) {
      throw new Error("Feed mapping grid is not available");
    }

    ctx.rows.value = await fetchFeedTypeMappingsList(players.getFeedTypeMappings, entityId, {
      isReadAfterWrite: true,
    });
    gate.markClean?.();
    notifySuccess();
  }

  return {
    kind: "grid",
    id: "feed-mapping",
    label: "Feed mapping",
    createGrid: (getValues) =>
      buildFeedMappingGrid(
        () => playerId(getValues()),
        players.getFeedTypeMappings.bind(players),
      ),
    createSubmitGate: createFeedMappingSubmitGate,
    save,
    addRowLabel: "common.buttons.add_new",
    onAddRow: addFeedMappingRow,
  };
}
